import React from 'react';
import './smallButton.style.scss'; // Make sure to include your stylesheet

const SmallButton = ({ text, option, clicked, onClick }) => {
    return (
        <div>
            {option === 'green' && (
                <div className={`small-button-green${clicked ? '-clicked' : ''}`} onClick={onClick}>
                    <p className='text'>{text}</p>
                </div>
            )}
            {option === 'small-blue-inverted' && (
                <div className={`small-blue-inverted${clicked ? '-clicked' : ''}`} onClick={onClick}>
                    <p>{text}</p>
                </div>
            )}
            {option === 'yellow' && (
                <div  onClick={onClick} className='small-button-yellow'>
                    <p className='text'>{text}</p>
                </div>
            )}
            {option === 'inactive' && (
                <div onClick={onClick} className='small-button-inactive'>
                    <p className='text'>{text}</p>
                </div>
            )}
            {option === 'red' && (
                <div onClick={onClick} className='small-button-red'>
                    <p className='text'>{text}</p>
                </div>
            )}
            {option === 'grey' && (
                <div className={`small-button-grey${clicked ? '-clicked' : ''}`} onClick={onClick}>
                    <p className='text'>{text}</p>
                </div>
            )}
            {option === 'small-button-linked-text' && (
                <div className={'small-button-linked-text'} onClick={onClick}>
                    <p>{text}</p>
                </div>
            )}
            {!option && (
                <div onClick={onClick} className='button'>
                    <p className='text'>{text}</p>
                </div>
            )}
        </div>
    );
};

export default SmallButton;